module.exports = __webpack_public_path__ + "static/media/google-play-350.8b23ac27.png";